/**
 * Determines the action type based on the provided endpoint name.
 *
 * @param endpointName - The name of the endpoint to evaluate.
 * @returns A string representing the action type:
 * - `'created'` if the endpoint name starts with "create" or "add" (case-insensitive).
 * - `'updated'` if the endpoint name starts with "update" (case-insensitive).
 * - `'deleted'` if the endpoint name starts with "delete" (case-insensitive).
 * - `'processed'` if none of the above conditions are met.
 */
export const getActionType = (endpointName: string) => {
  if (/^(create|add)/i.test(endpointName)) return 'created';
  if (/^update/i.test(endpointName)) return 'updated';
  if (/^delete/i.test(endpointName)) return 'deleted';
  return 'processed';
};
